"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = _interopRequireDefault(require("./settings/colors"));

var _grid = _interopRequireDefault(require("./settings/grid"));

var _spacing = _interopRequireDefault(require("./settings/spacing"));

var _fonts = _interopRequireDefault(require("./settings/fonts"));

var _zIndex = _interopRequireDefault(require("./settings/z-index"));

var _media = _interopRequireDefault(require("./settings/media"));

var _immersiveFlow = _interopRequireDefault(require("./settings/immersive-flow"));

var _shadows = _interopRequireDefault(require("./settings/shadows"));

var _button = _interopRequireDefault(require("./button"));

var _default = (0, _button.default)({
  colors: _colors.default,
  grid: _grid.default,
  spacing: _spacing.default,
  fonts: _fonts.default,
  zIndex: _zIndex.default,
  immersiveFlow: _immersiveFlow.default,
  media: _media.default,
  shadows: _shadows.default
});

exports.default = _default;
//# sourceMappingURL=masterTheme.js.map